module.exports = __webpack_public_path__ + "static/media/web_03.7eb09fc2.webp";